import { ajaxRequest } from "../Ajax/ajax";
import { successToast } from "../utils";
import { fillActivateStudents } from "../../Pages/AdminCourseManagement/Fills";
import { resetCourseListUserCounter } from "../../Pages/AdminCourseManagement/UserCounters";

export var deactivateAllUsers = function(courseId, btn:boolean|JQuery=false){

    const url = '/course/' + courseId.toString() + '/users/deactivate'

    const success = function(data){
        successToast('Es wurden erfolgreich alle Schüler/-innen des Kurses deaktiviert', 'Erfolg', 10000, true);
        resetCourseListUserCounter();
        fillActivateStudents(courseId);
    }

    ajaxRequest(url, success, {}, btn);

  }